import { z } from 'zod';
import { auctionsOfAuctionTileSortByValues } from 'src/apis/transport-auction/mappings';
import { directionValues } from 'src/components/data-display/direction';
import { networkPointOptionSchema } from 'src/components/form/select/network-point-select/network-point-multi-select';
import {
  ascSortDirectionSchema,
  formOptionSchema,
  getPaginationSchema,
} from 'src/components/form/zod-schemas';
import {
  optionalDefault,
  preprocessAsArray,
} from 'src/components/form/zod-utilities';
import { tsoOptionSchema } from 'src/pages/transport/auctions/tiles/tsos-filter';

export const auctionsParamsSchema = z
  .object({
    quickFilter: z.preprocess(
      optionalDefault('DEFAULT'),
      z
        .enum([
          // DEFAULT can resolve to either FAVOURITES_ONLY or OWN_AUCTIONS_ONLY or null depending on the user and auctions
          'DEFAULT',
          'FAVOURITES_ONLY',
          'OWN_AUCTIONS_ONLY',
          'QUICK_FILTER_ID',
        ])
        .nullable() // means "All"
        .default('DEFAULT')
    ),
    quickFilterId: z.string().nullable().default(null),
    sortBy: z
      .enum(auctionsOfAuctionTileSortByValues)
      .default('NETWORK_POINT_OR_BUNDLE_NAME'),
    sortDirection: ascSortDirectionSchema,
    networkPointOrBundleId: z.preprocess(
      preprocessAsArray,
      z.array(networkPointOptionSchema).default([])
    ),
    direction: z.preprocess(
      preprocessAsArray,
      z.array(z.enum(directionValues)).default([])
    ),
    operatorId: z.preprocess(
      preprocessAsArray,
      z.array(tsoOptionSchema).default([])
    ),
    capacityCategoryId: z.preprocess(
      preprocessAsArray,
      z.array(formOptionSchema).default([])
    ),
    marketableCapacityMin: z.coerce
      .number()
      .int('{label} cannot contain decimals.')
      .min(0)
      .nullable()
      .default(null),
    marketableCapacityMax: z.coerce
      .number()
      .int('{label} cannot contain decimals.')
      .min(0)
      .nullable()
      .default(null),
    runtimeIntersectionFilterStart: z.string().nullable().default(null),
    runtimeIntersectionFilterEnd: z.string().nullable().default(null),
    startingPriceMin: z.coerce.number().min(0).nullable().default(null),
    startingPriceMax: z.coerce.number().min(0).nullable().default(null),
    marketTransitionPriceMin: z.coerce.number().min(0).nullable().default(null),
    marketTransitionPriceMax: z.coerce.number().min(0).nullable().default(null),
    assignedAuctionId: z.string().nullable().default(null),
  })
  .merge(getPaginationSchema());
